import { BlindMatchInput } from "browser/components/atomic-elements/atoms/input/blind-match-input"
import LabelFieldFactory from "browser/components/atomic-elements/higher-order-components/label-field-factory"
export const BlindMatchInputField = LabelFieldFactory({ InputComponent: BlindMatchInput })
